export const breakpoints = {
  0: {
    slidesPerView: 1.5,
  },
  200: {
    slidesPerView: 2,
  },
  300: {
    slidesPerView: 2.3,
  },
  380: {
    slidesPerView: 2.5,
  },
  480: {
    slidesPerView: 3,
  },
  646: {
    slidesPerView: 3.2,
  },
  768: {
    slidesPerView: 2.6,
  },
  850: {
    slidesPerView: 2.7,
  },
  900: {
    slidesPerView: 3.2,
  },
  1120: {
    slidesPerView: 3.5,
  },
  1350: {
    slidesPerView: 4.5,
  },
};
